import {
    GET_ALL_CORP_SYSTEMS,
    GET_CORP_SYSTEM_LIST,
    LOADING_CORP_SYSTEM_LIST,
    START_ADD_CORP_SYSTEM, START_REMOVE_CORP_SYSTEM, START_UPDATE_CORP_SYSTEM,
    STOP_ADD_CORP_SYSTEM, STOP_REMOVE_CORP_SYSTEM
} from "../types";
import {httpWrapper} from "../../libs/http";

export const fetchCorpSystemList = (page = null, perPage = null, param = null) => {
    return async dispatch => {
        try {
            dispatch({
                type: LOADING_CORP_SYSTEM_LIST
            })

            let uri = '/corp_systems?'

            if(page && perPage){
                uri = uri + `page=${page}&limit=${perPage}`;
            }
            if(param){
                uri = param.param ? uri + `&${param.typeParam}=${param.param}` : uri;
            }

            const response = await httpWrapper(uri, {credentials: "include"});
            if(!response.ok){
                let error = await response.json()
                throw new Error(error.message)
            }
            const result = await response.json()

            dispatch({
                type: GET_CORP_SYSTEM_LIST,
                payload: result
            })

        }catch (e){

            throw new Error(e.message)

        }
    }
}

export const fetchAllCorpSystem = () => {
    return async dispatch => {
        try {
            dispatch({
                type: LOADING_CORP_SYSTEM_LIST
            })

            const response = await httpWrapper('/corp_systems', {credentials: "include", mode: "cors"});

            const result = await response.json()
            if(!response.ok){
                let error = await response.json()
                throw new Error(error.message)
            }
            dispatch({
                type: GET_ALL_CORP_SYSTEMS,
                payload: result
            })
        } catch (e) {
            throw new Error(e.message)
        }
    }
}

export const addCorpSystem = (data) => {
    return async dispatch => {
        try {
            dispatch({
                type: START_ADD_CORP_SYSTEM
            })

            const response = await httpWrapper('/corp_systems', {
                method: 'post',
                credentials: "include",
                mode: "cors",
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            if(!response.ok){
                let error = await response.json()
                throw new Error(error.message)
            }
            const result = await response.json()

            dispatch({
                type: STOP_ADD_CORP_SYSTEM
            })

        } catch (e) {
            throw new Error(e.message)
        }
    }
}

export const updateCorpSystem = (data, strCode) => {
    return async dispatch => {
        try {
            dispatch({
                type: START_UPDATE_CORP_SYSTEM
            })

            const response = await httpWrapper(`/corp_systems/${strCode}`, {
                method: 'put',
                credentials: "include",
                mode: "cors",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });

            if(!response.ok){
                let error = await response.json()
                throw new Error(error.message)
            }

            const result = await response.json()

            dispatch({
                type: STOP_ADD_CORP_SYSTEM
            })

        } catch (e) {
            throw new Error(e.message)
        }
    }
}

export const removeCorpSystem = (strCode) => {
    return async dispatch => {
        try {
            dispatch({
                type: START_REMOVE_CORP_SYSTEM
            })
            const response = await httpWrapper(`/corp_systems/${strCode}`, {
                method: 'delete',
                credentials: "include",
                mode: "cors"
            });
            if(!response.ok){
                let error = await response.json()
                throw new Error(error.message)
            }
            const result = await response.json()
            dispatch({
                type: STOP_REMOVE_CORP_SYSTEM
            })
        } catch (e) {
            throw new Error(e.message)
        }
    }
}